import { createFileRoute } from '@tanstack/react-router'

import PageWorkflow from '../pages/PageWorkflow'

export const Route = createFileRoute('/workflow/$workflowId/')({
  // Each workflow, including `new`, owns its editor state. The router otherwise
  // reuses the page across IDs and carries prompts and selections between them.
  remountDeps: ({ params }) => params,
  component: PageWorkflow
})
